import {
  NavigationProp,
  ParamListBase,
  RouteProp,
  useNavigation,
  useRoute,
} from "@react-navigation/native";
import { useCallback } from "react";

import { BaseNavigatorParamList } from "@/navigators/BaseNavigator/types";

import { KnownEvent, HookTrackEvent, EventPropertiesMap } from "../../events";
import { trackEvent } from "../trackEvent/trackEvent";

/**
 *
 * Automatically adds the club slug.
 */
export const useTrackEvent = (): HookTrackEvent => {
  const route = useRoute<RouteProp<BaseNavigatorParamList, "Club">>();
  const routeClubSlug = route?.params?.clubSlug;
  const navigation = useNavigation<NavigationProp<ParamListBase>>();

  const getClubSlugFromParents = (): string | undefined => {
    let parent = navigation.getParent();
    while (parent) {
      const state = parent.getState();
      for (const r of state.routes) {
        const params = (r as { params?: { clubSlug?: string } }).params;
        if (params?.clubSlug) return params.clubSlug;
      }
      parent = parent.getParent?.();
    }
    return undefined;
  };

  const clubSlug = routeClubSlug ?? getClubSlugFromParents() ?? "unknown";
  const track = useCallback(
    <E extends KnownEvent>(event: E, properties: EventPropertiesMap[E]) => {
      const props = {
        ...properties,
        clubSlug,
      } as EventPropertiesMap[E] & { clubSlug: string };
      trackEvent(event, props);
    },
    [clubSlug]
  );

  return track;
};
